import MarketingMessages from './MarketingMessages';
export default MarketingMessages;